import { render, staticRenderFns } from "./opt-show.vue?vue&type=template&id=04dec0f5&scoped=true&"
import script from "./opt-show.vue?vue&type=script&lang=js&"
export * from "./opt-show.vue?vue&type=script&lang=js&"
import style0 from "./opt-show.vue?vue&type=style&index=0&id=04dec0f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04dec0f5",
  null
  
)

export default component.exports